<template>
  <v-dialog
    v-model="dialog"
    :transition="smAndDown ? 'scroll-x-reverse-transition' : 'fade'"
    :scrollable="smAndDown"
    :fullscreen="smAndDown"
    max-width="1100px"
  >
    <v-card v-if="!loading" class="px-md-9 py-md-15 item">
      <div>
        <HeaderToBackShell v-if="smAndDown" :title="item.title">
          <template v-if="config.shopping_cart" #right-button>
            <v-btn
              @click="shoppingCartOpen"
              :class="{ 'mr-2': totalItemsCart, 'mr-n1': !totalItemsCart }"
              color="transparent"
              depressed
              small
              fab
            >
              <v-icon size="20" color="secondary">fa-shopping-cart</v-icon>

              <v-badge
                v-if="totalItemsCart"
                class="ml-1 mb-2"
                color="white"
                :content="totalItemsCart"
                top
                right
              ></v-badge>
            </v-btn>
          </template>
        </HeaderToBackShell>
      </div>

      <v-card-text class="d-flex d-md-block flex-column pa-0" height="100%">
        <v-row class="d-block d-md-flex ma-0 ma-md-n5">
          <v-col cols="12" md="5" class="align-start pt-0 pb-3 px-3 pa-md-5">
            <hooper-container
              class="slides-container"
              style="height: auto"
              ref="productImages"
              :wheelControl="false"
              :itemsToShow="1"
              :mouseDrag="item.img.length > 1"
              :touchDrag="item.img.length > 1"
              :infiniteScroll="item.img.length > 1"
            >
              <template v-for="(img, keyImages) in item.img">
                <hooper-slide
                  :key="keyImages"
                  v-if="img"
                  class="rounded-lg overflow-hidden"
                >
                  <img
                    class="d-block item-img"
                    :src="files + img + '?resize=1&w=550'"
                    :alt="item.title"
                    height="100%"
                    width="100%"
                  />
                </hooper-slide>
              </template>
            </hooper-container>
          </v-col>

          <v-col
            cols="12"
            md="7"
            class="d-flex flex-column justify-space-between pa-3 pa-md-5"
          >
            <div>
              <div
                v-if="item.category && item.category"
                class="
                  d-inline-flex
                  align-self-start
                  secondary--text
                  text-body-2
                  font-weight-medium
                  py-1
                  px-2
                  item-category
                "
              >
                {{ item.category }}
              </div>

              <TitleWidget class="mt-2">
                {{ item.title }}
              </TitleWidget>

              <div
                v-if="item.subtitle"
                class="grey--text text-body-2 mt-md-1 item-text"
              >
                {{ item.subtitle }}
              </div>

              <div
                v-if="item.text"
                class="grey--text text--darken-1 text-body-1 mt-2 item-text"
              >
                {{ item.text }}
              </div>

              <div class="secondary--text text-h6 font-weight-bold mt-2">
                {{ item.price ? formatPrice(item.price) : "Sob Consulta" }}
              </div>

              <template v-if="item.variants.length">
                <div
                  class="
                    secondary--text
                    text-subtitle-1
                    font-weight-medium
                    mt-3
                  "
                >
                  {{ item.variant_title || "Variações" }}
                </div>

                <div class="d-flex flex-wrap mt-1 variants-grid">
                  <template v-for="(variant, keyVariants) in item.variants">
                    <v-btn
                      :key="keyVariants"
                      @click="variantSelected = variant"
                      class="
                        text-body-1
                        font-weight-bold
                        py-3
                        px-4
                        variants-grid-item
                      "
                      color="secondary"
                      min-width="auto"
                      min-height="auto"
                      height="auto"
                      :outlined="variant.id != variantSelected.id"
                      depressed
                      tile
                    >
                      {{ variant.title }}
                    </v-btn>
                  </template>
                </div>
              </template>

              <div class="mt-3">
                <div
                  @click="showObservations = true"
                  class="secondary--text text-subtitle-1 font-weight-medium"
                  :class="{ 'cursor-pointer': !showObservations }"
                >
                  <v-icon color="secondary" size="20" left>
                    fa-comment-alt
                  </v-icon>
                  {{
                    showObservations
                      ? "Alguma observação?"
                      : "Adicionar observação"
                  }}
                </div>

                <transition name="scroll-y-transition">
                  <v-textarea
                    v-if="showObservations"
                    v-model="observations"
                    class="
                      grey--text
                      text--darken-1 text-body-1
                      rounded-lg
                      mt-3
                      item-observations
                    "
                    background-color="#F1F1F1"
                    placeholder="Descreva observações sobre seu pedido"
                    hide-details
                    no-resize
                    outlined
                    rows="3"
                  ></v-textarea>
                </transition>
              </div>
            </div>

            <div v-if="!smAndDown" class="d-flex justify-end mt-6">
              <div class="align-center rounded mr-4 item-amount">
                <v-btn
                  class="grey--text px-0 mx-auto"
                  @click="quant--"
                  :disabled="quant <= 1"
                  color="white"
                  min-width="0"
                  height="20px"
                  width="20px"
                  depressed
                  text
                >
                  <v-icon size="10">fa-minus</v-icon>
                </v-btn>

                <div class="text-body-1 text-center">
                  {{ quant }}
                </div>

                <v-btn
                  class="primary--text px-0 mx-auto"
                  @click="quant++"
                  color="white"
                  min-width="0"
                  height="20px"
                  width="20px"
                  text
                >
                  <v-icon size="10">fas fa-plus</v-icon>
                </v-btn>
              </div>

              <v-btn
                @click.stop="shoppingCartAction"
                class="
                  white--text
                  text-body-1 text-none
                  font-weight-medium
                  px-4
                "
                color="primary"
                height="45px"
                width="225px"
                depressed
              >
                <v-icon class="mr-2" color="white" size="18">
                  fab fa-whatsapp
                </v-icon>
                Peça pelo WhatsApp
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="smAndDown" class="ma-0 ma-md-n5">
          <v-col class="mt-auto" cols="12">
            <div class="d-flex justify-space-between">
              <div class="align-center rounded mr-4 item-amount">
                <v-btn
                  class="grey--text px-0 mx-auto"
                  @click="quant--"
                  :disabled="quant <= 1"
                  color="white"
                  min-width="0"
                  height="20px"
                  width="20px"
                  depressed
                  text
                >
                  <v-icon size="10">fa-minus</v-icon>
                </v-btn>

                <div class="text-body-1 text-center">
                  {{ quant }}
                </div>

                <v-btn
                  class="primary--text px-0 mx-auto"
                  @click="quant++"
                  color="white"
                  min-width="0"
                  height="20px"
                  width="20px"
                  text
                >
                  <v-icon size="10">fas fa-plus</v-icon>
                </v-btn>
              </div>

              <v-btn
                @click.stop="shoppingCartAction"
                class="
                  white--text
                  text-body-1 text-none
                  font-weight-medium
                  px-4
                "
                color="primary"
                height="45px"
                width="220px"
                depressed
              >
                <v-icon class="mr-2" color="white" size="18">
                  fa-whatsapp
                </v-icon>
                Peça pelo WhatsApp
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TitleWidget from "./TitleWidget.vue";
import HeaderToBackShell from "../shell/HeaderToBackShell.vue";
import { formatPrice } from "../../utils/formatPrice";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

const _config = {
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
    dialog: false,
    showObservations: false,
    observations: "",
    item: {},
    quant: 1,
    variantSelected: null,
    gtmSubmitEvent: "add_to_shopping_cart",
  }),
  created() {
    this.$rest(_config.mod).get();
    this.getItem();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, subtitle, price, variants, category, text }) => ({
          id,
          img: [
            img.featured,
            ...img.list
              .filter(({ path }) => img.featured !== path)
              .map(({ path }) => {
                return path;
              }),
          ],
          title,
          subtitle,
          price,
          variants,
          category: category.title,
          variant_title: category.variant_title,
          text,
        })
      );
    },
    totalItemsCart() {
      return this.$shoppingCart.container.items.reduce(
        (r, { state: { quant } }) => r + quant,
        0
      );
    },
    informations() {
      return this.$rest("informations").item;
    },
    config() {
      return this.$rest("config").item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getItem() {
      if (!this.$route.params.item) {
        this.dialog = false;
        return false;
      }

      this.loading = true;
      this.showObservations = false;
      this.observations = "";
      this.quant = 1;
      this.variantSelected = null;

      const itemId = Number(
        this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1")
      );

      this.item = this.items.filter(({ id }) => id === itemId).shift();

      if (this.item.variants.length) {
        const variant = this.item.variants.reduce((item, currentItem) => {
          return !!currentItem &&
            Number(currentItem.price) <= Number(item.price)
            ? currentItem
            : item;
        });

        this.variantSelected = variant;
      }

      this.dialog = true;
      document.title = `${this.item.title} - ${this.informations?.name}`;

      this.loading = false;

      setTimeout(() => {
        this.$refs.productImages.updateWidth();
      }, 300);
    },
    shoppingCartOpen() {
      this.dialog = false;

      setTimeout(() => {
        this.$shoppingCart.open = true;
      }, 100);
    },
    formatPrice,
    shoppingCartAction() {
      if (this.config.shopping_cart) this.addToShoppingCart();
      else this.finishShoppingCart();
    },
    async finishShoppingCart() {
      this.$shoppingCart.container.clear();

      this.addToShoppingCart(false);

      const items = this.$shoppingCart.container.items;

      const products = items.map(
        ({ state: { id, observations, quant, variant } }) => ({
          id,
          observations,
          quant,
          variant,
        })
      );

      const data = await this.$rest("orders").post({
        data: {
          products,
        },
      });

      const text = encodeURIComponent(data.text);

      const url =
        getWhatsappLinkFromPhone(this.config.whatsapp) + "?text=" + text;

      this.$shoppingCart.container.clear();

      window.open(url, "_self");
    },
    addToShoppingCart(toast = true) {
      let { id, title, price } = this.item;
      const img = this.item.img[0];
      const observations = this.observations;
      const quant = this.quant;
      const variant = this.variantSelected;

      if (variant) price = variant.price;

      if (window.dataLayer && this.gtmSubmitEvent) {
        window.dataLayer.push({ event: this.gtmSubmitEvent });
      }

      this.$shoppingCart.container.add({
        id,
        img,
        title,
        price,
        observations,
        quant,
        variant,
      });

      if (toast) {
        this.$toast.success(
          `${
            quant > 1 ? quant + "x " : ""
          }${title} foi adicionado ao carrinho.`,
          {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: false,
            draggablePercent: 0.1,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: false,
            icon: "fas fa-cart-plus",
            rtl: false,
          }
        );

        this.dialog = false;
      }
    },
  },
  watch: {
    $route() {
      this.getItem();
    },
    dialog(v) {
      if (!v && this.$route.path !== "/") this.$router.push("/");
    },
    variantSelected(v) {
      if (v) this.item.price = v.price;
    },
  },
  components: {
    TitleWidget,
    HeaderToBackShell,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 1;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    width: 100%;
  }

  &-category {
    border: 1px solid var(--v-secondary-base);
    border-radius: 2px;
  }

  &-observations::v-deep {
    fieldset {
      border: 0 !important;
    }
  }

  &-amount {
    border: 1px solid #e1e1e1;
    display: grid;
    gap: 0;
    grid-template-columns: 30px 50px 30px;
  }
}

.item::v-deep {
  .v-badge__badge {
    border: 1px solid var(--v-secondary-base) !important;
    color: var(--v-secondary-base);
  }
}

.slides-container::v-deep {
  ul,
  ol {
    padding: 0 !important;
  }
}

.variants-grid {
  .variants-grid-item {
    margin-left: -1px;
    margin-top: -1px;
  }

  .variants-grid-item::v-deep {
    .v-btn__content {
      max-width: 100%;
      white-space: normal;
    }
  }
}
</style>
